module.exports = __webpack_public_path__ + "static/images/callout_5.c5e3cd20fb6d1ae53bd114f9ad63611b.jpg";